<template>
  <PageRelevant :list="expand.list" />
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';
import PageRelevant from '@template/page/_component/relevant.vue';

export default {
  name: 'plan_content',
  components: {
    PageRelevant
  },
  data(): DataInterface {
    return {
      expand: {
        list: [
          'news_1',
          'product_1',
          'plan_2'
        ]
      }
    };
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/planMigrate/';
</style>